import { RootState } from 'app/store';

export const selectContractDetails = (state: RootState) =>
  state.contractDetails.contract;

export const selectContractDetailsLoading = (state: RootState) =>
  state.contractDetails.loading;

export const selectContractDetailsError = (state: RootState) =>
  state.contractDetails.error;
